import { render, staticRenderFns } from "./Body_panel.vue?vue&type=template&id=6ad43930&scoped=true&"
import script from "./Body_panel.vue?vue&type=script&lang=js&"
export * from "./Body_panel.vue?vue&type=script&lang=js&"
import style0 from "./Body_panel.vue?vue&type=style&index=0&id=6ad43930&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad43930",
  null
  
)

component.options.__file = "Body_panel.vue"
export default component.exports